import React, { useState } from 'react';
import Modal from 'react-modal';
import cx from '../../../styles';
import { gtmSend } from '../../../helpers';
import { mobileCheck } from '@tickled-media/web-components.tm-helpers'

const UserDataSharingModal = (props) => {
    const [content, setContent] = useState({});

    const isMobile = mobileCheck();

    const fetchData = () => {
        if(props.dataSharing){
            setContent(props.permissionInfo)
        }
        else if(props.permissionInfo && props.dataSharingCheck){
            setContent(props.permissionInfo.start_data_sharing)
            gtmSend('settings_dataShare', 'Settings', 'Data Sharing Permission', 'Preliminary Popup', '', {'action_detail' : 'Preliminary Popup', 'platform' : isMobile ? 'Mobile Web' : 'Desktop Web'});
        }
        else if(props.permissionInfo){
            setContent(props.permissionInfo.stop_data_sharing)
            gtmSend('settings_dataShare', 'Settings', 'Data Sharing Permission', 'Stop Data Sharing Popup', '', {'action_detail' : 'Stop Data Sharing Popup', 'platform' : isMobile ? 'Mobile Web' : 'Desktop Web'});
        }
    }

    const negativeAction = () => {
        if(props.dataSharing){
            props.confirmDataSharing(0);
            props.togglePopup(); 
        }
        else{
            props.togglePopup(); 
            props.negativeActionToggle();
        }
        if(props.permissionInfo && props.dataSharingCheck) {
            gtmSend('settings_dataShare', 'Settings', 'Data Sharing Permission', 'Preliminary Popup - No', '', {'action_detail' : 'Preliminary Popup - No', 'platform' : isMobile ? 'Mobile Web' : 'Desktop Web'});   
        } else {
            gtmSend('settings_dataShare', 'Settings', 'Data Sharing Permission', 'Stop Data Sharing Popup - Cancel', '', {'action_detail' : 'Stop Data Sharing Popup - Cancel', 'platform' : isMobile ? 'Mobile Web' : 'Desktop Web'});   
        }
    }

    const postiveAction = () => {
        if(props.dataSharing){
            props.confirmDataSharing(1);
            props.togglePopup(); 
        }
        else{
            props.togglePopup(); 
            if(props.permissionInfo && props.dataSharingCheck) {
                gtmSend('settings_dataShare', 'Settings', 'Data Sharing Permission', 'Preliminary Popup - Yes', '', {'action_detail' : 'Preliminary Popup - Yes', 'platform' : isMobile ? 'Mobile Web' : 'Desktop Web'});   
            } else {
                gtmSend('settings_dataShare', 'Settings', 'Data Sharing Permission', 'Stop Data Sharing Popup - Confirm', '', {'action_detail' : 'Stop Data Sharing Popup - Confirm', 'platform' : isMobile ? 'Mobile Web' : 'Desktop Web'});   
            }
        }
    }
    return (
        <Modal
            isOpen={props.showPopup}
            onAfterOpen={fetchData}
            overlayClassName={"user-data-sharing-modal"}
        >
            <div className={cx('content-wrap')}>
                {content.icon && content.icon.length && <img className={cx('icon')} src={content.icon}/>}
                <div className={cx('title')}>{content.title}</div>
                <p className={cx('primary-text')}>{content.primary_text}</p>
                <div className={cx('secondary-content')}>
                    {content.secondary_icon && content.secondary_icon.length && <img className={cx('secondary-icon')} src={content.secondary_icon}/>}
                    <p className={cx('secondary-text')}>{content.secondary_text}</p>
                </div>
                <div className={cx('button-wrap')}>
                    {content.negative_action_text && <button className={cx('negative')} onClick={negativeAction}>{content.negative_action_text.charAt(0).toUpperCase() + content.negative_action_text.slice(1)}</button>}
                    {content.postive_action_text && <button className={cx('positive')} onClick={postiveAction}>{content.postive_action_text.charAt(0).toUpperCase() + content.postive_action_text.slice(1)}</button>}
                </div>
            </div>
        </Modal>
    );
}

export default UserDataSharingModal;